const actionTypes = {
  START: 'INFOWIJS_AUTHENTICATION/START',
  SET_SESSION_REQUEST: 'INFOWIJS_AUTHENTICATION/SET_SESSION_REQUEST',
  SET_RANDOM_SESSION_IDENTIFIER: 'INFOWIJS_AUTHENTICATION/SET_RANDOM_SESSION_IDENTIFIER',
  VERIFY_SESSION_REQUEST: 'INFOWIJS_AUTHENTICATION/VERIFY_SESSION_REQUEST',
  VERIFY_TRANSFER_TOKEN: 'INFOWIJS_AUTHENTICATION/VERIFY_TRANSFER_TOKEN',
  SET_ACCESS_TOKEN: 'INFOWIJS_AUTHENTICATION/SET_ACCESS_TOKEN',
  SIGN_OUT: 'INFOWIJS_AUTHENTICATION/SIGN_OUT',
  SET_ERROR: 'INFOWIJS_AUTHENTICATION/SET_ERROR',
}

export default actionTypes
